export default __webpack_public_path__ + "static/media/signup.0c256f66.jpg";